export default "__VITE_ASSET__Clmt4gJ___"